<template>
  <div>
    <div class="pay">
      <!-- <div class="pay-item" @click="selectBacks(5)">
        <img class="pay-img" :src="require('@/assets/bank/zfb.png')" style="border-radius: 10px;">
        <span class="pay-name">支付宝</span>
      </div> 
      <div class="pay-item" @click="selectBacks(6)">
        <img class="pay-img" :src="require('@/assets/bank/wx.png')">
        <span class="pay-name">微信支付</span>
      </div> -->
      <div class="pay-item" @click="selectBacks(7)">
        <img class="pay-img" :src="require('@/assets/bank/pay.png')">
        <span class="pay-name">网银支付</span>
      </div>
      <div class="pay-item" @click="selectBacks(1)">
        <img class="pay-img" :src="require('@/assets/bank/zhong.png')" style="width: 46px;height: 46px;padding: 2px;">
        <span class="pay-name">宝付支付</span>
      </div>
      <!-- <div class="pay-item" @click="selectBacks(8)">
        <img class="pay-img" :src="require('@/assets/bank/lkl.png')">
        <span class="pay-name">拉卡拉支付</span>
      </div> -->
      <!-- <div class="pay-item" @click="selectBacks(1)">
        <img class="pay-img" :src="require('@/assets/bank/yin.png')">
        <span class="pay-name">银联支付</span>
      </div> 
      <div class="pay-item" @click="selectBacks(2)">
        <img class="pay-img" :src="require('@/assets/bank/pay.png')">
        <span class="pay-name">网银支付</span>
      </div>
      <div class="pay-item" @click="selectBacks(3)">
        <img class="pay-img" :src="require('@/assets/bank/zhong.png')" style="margin-left:20px;width: 47px;height: 47px">
        <span class="pay-name">中信全付通</span>
      </div>
      <div class="pay-item" @click="selectBacks(4)">
        <img class="pay-img" :src="require('@/assets/bank/b2b.png')" style="height: 46px">
        <span class="pay-name">中信B2B</span>
      </div> -->
    </div>
    <!-- 表单弹窗 -->
    <el-dialog
      title="银行卡"
      append-to-body
      :visible.sync="formVisible"
      width="600px"
      :before-close="closeDialog"
    >
      <SelectBack
        ref="formModal"
        :type="type"
        :records='records'
        v-if="formVisible"
        @ok="editSuccess"
        append-to-body
      />
    </el-dialog>
    <!-- 表单弹窗 -->
    <el-dialog
      title="微信支付"
      append-to-body
      :visible.sync="wxVisible"
      width="400px"
    >
      <Wxpay
        ref="formModal"
        :img='img'
        v-if="wxVisible"
        @payOk="payOk"
        append-to-body
      />
    </el-dialog>

    <!-- 表单弹窗 -->
    <el-dialog
      title="添加银行卡"
      append-to-body
      :visible.sync="formBankVisible"
      width="600px"
      :before-close="closeBankDialog"
    >
      <BankForm
        ref="formModal"
        :record="bankRecord"
        :type="type"
        v-if="formBankVisible"
        @editBankSuccess="editBankSuccess"
        append-to-body
      />
    </el-dialog>

  </div>
</template>

<script>
import SelectBack from "./selectBack";
import { publicPay, zhongxinPay, ecepcpay, zfbwebPay, wxwebPay, bankIndex } from '@/api'
import Wxpay from "./wxpay.vue";
import BankForm from "../../user/bankForm";
export default {
  components: {
    SelectBack,
    Wxpay,
    BankForm
  },
  props: {
    record: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formVisible: false,
      bankRecord: {},
      type:1,
      records: {},
      img: '',
      wxVisible: false,
      formBankVisible: false
    }
  },
  mounted(){
    this.records = this.record
  },
  methods: {
    // 关闭微信支付
    payOk(){
      this.wxVisible = false
      this.$emit('ok')
    },
    // 关闭弹框
    closeDialog() {
      this.type = 1;
      this.formVisible = false;
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false;
      // this.getOrderIndex();  //刷新列表
    },
    selectBacks(num){
      if(num == 1){
        // publicPay({order_id:this.record.id}).then(res => {
        //   if(res.code == 1){
        //     window.open(res.data, '_blank');
        //   }else{
        //     this.$message.error(res.msg);
        //   }
        // })
        bankIndex({
          u_id:JSON.parse(window.localStorage.getItem("userInfo")).id,
          page: 1,
          limit: 1000
        }).then(res => {
          if(res.code == 1){
            if(res.data.total > 0){
              this.type = num
              this.formVisible = true
            }else{
              this.type = num 
              this.formBankVisible = true
            }
          }
        })
      }else if(num == 2){
        this.type = num
        this.formVisible = true
      }else if(num == 3){
        zhongxinPay({order_id:this.record.id}).then(res => {
          if(res.code == 1){
            window.open(res.data.CODEURL, '_blank');
          }else{
            this.$message.error(res.msg);
          }
        })
      }else if(num == 4){
        ecepcpay({order_id:this.record.id}).then(res => {
          if(res.code == 1){
            window.open(res.data.REDIRECTURL, '_blank');
          }else{
            this.$message.error(res.msg);
          }
        })
      }else if(num == 5){
        this.$emit('zfbOk')
        window.open(`https://jcgyl.cc/api/order/zfb_web?order_id=${this.record.id}&source=1`, '_blank');
      }else if(num == 6){
        wxwebPay({order_id:this.record.id}).then(res => {
          if(res.code == 1){
            this.wxVisible = true
            this.img = res.data.qrcode_url
          }else{
            this.$message.error(res.msg);
          }
        })
      } else if(num == 7){
        window.open(`https://jcgyl.cc/api/order/upgpay?order_id=${this.record.id}`, '_blank');
      } else if(num == 8){
        window.open(`https://jcgyl.cc/api/order/la_ka_la_pay?order_id=${this.record.id}&origin=2`, '_blank');
      }
    },
    // 关闭银行弹窗
    closeBankDialog() {
      this.bankRecord = {};
      this.formBankVisible = false;
    },
    // 添加银行卡成功后
    editBankSuccess(type){
      this.type = type
      this.formBankVisible = false;
      this.formVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
  .pay{
    width: 100%;
    box-sizing: border-box;
    padding:20px 40px;
    .pay-item{
      width: 100%;
      height: 70px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ccc;
      border-radius: 4px;
      cursor: pointer;
      .pay-img{
        height: 50px;
        width: 50px;
        margin-right: 50px;
        // background: #fff;
      }
      .pay-name{
        font-size: 20px;
      }
    }
    .pay-item:hover{
      // background: #409EFF;
      background: #00AECF;
      .pay-name{
        color: #fff;
      }
    }
  }
</style>